import React, { useState } from "react";
import axios from "axios";
import "./verifyotp.css";

const VerifyOTP = () => {
  const [phone, setPhone] = useState("");
  const [otp, setOtp] = useState("");
  const [otpVerified, setOtpVerified] = useState(false);
  const [otpMessage, setOtpMessage] = useState({ text: "", type: "" });
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [popup, setPopup] = useState({ show: false, type: "", message: "" });

  const handleOTPSubmit = async (e) => {
    e.preventDefault();
    if (!phone || !otp) {
      setOtpMessage({ text: "Enter phone and OTP!", type: "error" });
      return;
    }

    try {
      const res = await axios.post("https://bodhimaram.onrender.com/api/auth/verify-otp", {
        phone,
        otp,
      });

      if (res.data.success) {
        setOtpVerified(true);
        setOtpMessage({ text: "OTP Verified ✅", type: "success" });
      } else {
        setOtpMessage({ text: res.data.error, type: "error" });
      }
    } catch (err) {
      setOtpMessage({
        text: err.response?.data?.error || "Something went wrong!",
        type: "error",
      });
    }
  };

  const handlePasswordReset = async (e) => {
    e.preventDefault();
    if (password !== confirmPassword) {
      setPopup({ show: true, type: "error", message: "Passwords do not match!" });
      return;
    }

    try {
      const res = await axios.post("https://bodhimaram.onrender.com/api/auth/reset-password-otp", {
        phone,
        password,
      });

      setPopup({
        show: true,
        type: res.data.success ? "success" : "error",
        message: res.data.message || res.data.error,
      });
    } catch (err) {
      setPopup({ show: true, type: "error", message: "Server error!" });
    }
  };

  return (
    <div className="otp-container">
      <div className="otp-box">
        <h2>Verify OTP</h2>

        {!otpVerified && (
          <form onSubmit={handleOTPSubmit}>
            <input
              type="text"
              placeholder="Phone number"
              value={phone}
              onChange={(e) => setPhone(e.target.value)}
              className="input-field10"
            />
            <input
              type="text"
              placeholder="OTP"
              value={otp}
              onChange={(e) => setOtp(e.target.value)}
              className="input-field10"
            />
            {otpMessage.text && (
              <p className={`otp-message ${otpMessage.type}`}>{otpMessage.text}</p>
            )}
            <button type="submit" className="submit-btn">
              Verify OTP
            </button>
          </form>
        )}

        {otpVerified && (
          <form onSubmit={handlePasswordReset}>
            <input
              type="password"
              placeholder="New Password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              className="input-field"
              required
            />
            <input
              type="password"
              placeholder="Confirm Password"
              value={confirmPassword}
              onChange={(e) => setConfirmPassword(e.target.value)}
              className="input-field"
              required
            />
            <button type="submit" className="submit-btn">
              Reset Password
            </button>
          </form>
        )}
      </div>

      {popup.show && (
        <div className="popup-overlay">
          <div className={`popup-box ${popup.type}`}>
            <div className="popup-icon">{popup.type === "success" ? "✔" : "✖"}</div>
            <p>{popup.message}</p>
            <button
              onClick={() => setPopup({ show: false, type: "", message: "" })}
            >
              OK
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

export default VerifyOTP;
